<template>
  <div class="expandable-item">
    <div class="item-container">
      <div class="item-toggle" v-on:click="toggleExpand()">
        <div class="item-title">{{ title }}</div>
        <img :src="require('@/assets/icons/arrow-left.svg')" class="arrow" :class="{ expanded: expanded }">
      </div>
      <div v-if="expanded" class="item-content" v-html="content"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ExpandableItem',
  props: [
    'title',
    'content',
  ],
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded;
      if (this.expanded) {
        this.$emit('expanded', this.title);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../node_modules/base-ui/src/scss/riseup-colors';

  .expandable-item {

    .item-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 305px;

      .item-title {
        font-family: GretaSans;
        line-height: 1;
        font-size: 20px;
        margin: 17px 22px 20px 0;
        width: 100%;
      }

      .arrow {
        margin: 11px 10px 11px 15px;
        &.expanded {
          transform: rotate(-90deg);
        }
      }

      .item-content {
        height: 100%;
        padding: 22px;
        font-family: SimplerPro;
        font-size: 16px;
        line-height: 1.5;
        border-bottom: solid 1px;
        border-bottom-color: $riseup_gray_0;

        /deep/ .bold {
          font-family: SimplerProBold;
        }

        /deep/ .small {
          margin-top: 5px;
          display: block;
          font-size: 11px;
          line-height: 14px;
        }

        /deep/ .sub-header {
          color: $riseup_light_blue;
          font-family: SimplerProBold;
        }
      }
    }

    .item-toggle {
      display: flex;
      justify-content: space-between;
      background-color: $riseup_white;
      border-bottom: solid 1px $riseup_gray_0;
      box-shadow: 0 2px 3px 0 rgba(155, 155, 155, 0.51)
    }
  }

</style>



// WEBPACK FOOTER //
// src/base-components/ExpandableItem.vue